import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChartLine = () => {
  return (
    <g>
      <path d="M13.75 1a2.25 2.25 0 1 1-.375 4.469l-2.72 4.895a.75.75 0 0 1-1.106.235l-.08-.069-3.297-3.297-2.236 4.027a2.25 2.25 0 1 1-1.312-.729l2.72-4.895A.75.75 0 0 1 6.451 5.4l.08.069 3.296 3.296 2.237-4.026A2.25 2.25 0 0 1 13.75 1zM2.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5zm11.5-9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5z" />
    </g>
  );
};

export default withIcon(IconChartLine);
